import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import styles from "./../../style.module.scss";
import { useTranslation } from "react-i18next";
import { Button, Modal, Card, Row, Col, Space, Spin } from "antd";

// redux & query
import { setInspectModalVisible } from "../../goSlice";
import { useAppSelector, useAppDispatch } from "store/hook";

const Finished_Modal: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { ticket } = useParams();

  const [visible, setVisible] = useState(false);

  const { ticketData } = useAppSelector((state) => state.goPage);

  useEffect(() => {
    if (ticketData.ticket_inf.ticket === ticket) {
      if (ticketData.ticket_inf.expire_utc - Math.floor(Date.now()) / 1000 <= 0 || !ticketData.ticket_inf.active) {
        setVisible(false);
      } else if (
        ticketData.ticket_type === "inspection" &&
        ticketData.ticket_inf.progress.fix.done === ticketData.ticket_inf.progress.fix.total
      ) {
        setVisible(true);
      } else if (
        ticketData.ticket_type === "installation" &&
        ticketData.ticket_inf.progress.new.done === ticketData.ticket_inf.progress.new.total
      ) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    }
  }, [ticketData.ticket_inf]);

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <Modal
        title={""}
        visible={visible}
        centered
        onOk={handleOk}
        onCancel={handleCancel}
        className={styles.modalWrap}
        footer={[
          <Button
            type="primary"
            key="Submit"
            onClick={() => {
              setVisible(false);
            }}
          >
            {t("ISMS.Close")}
          </Button>,
        ]}
      >
        <Row justify="center" align="middle" style={{ height: "12vh" }}>
          <Col style={{ fontSize: "16px" }}>{`${t("ISMS.TicketFinished")}!`}</Col>
        </Row>
      </Modal>
    </>
  );
};

export default Finished_Modal;
